module.exports = __webpack_public_path__ + "media/MRI-ExemploA.86aff14a.mp3";